






























































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';

import {
  TBusinessReferralType,
  EBusinessReferralType
} from '@/models/marketingCenter/referral';

import ReferralExisting from '@/components/icons/ReferralExisting.vue';
import ReferralNew from '@/components/icons/ReferralNew.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import CouponCoinsPreview from '@/components/molecules/CouponPreview/CouponCoinsPreview.vue';
import CouponPercentagePreview from '@/components/molecules/CouponPreview/CouponPercentagePreview.vue';
import SetupCoupon from '@/components/molecules/Referral/SetupCoupon/SetupCoupon.vue';
import RewardCoin from '@/components/atoms/RewardCoin/RewardCoin.vue';

@Component({
  components: {
    ReferralExisting,
    ReferralNew,
    CoinsIcon,
    CouponCoinsPreview,
    CouponPercentagePreview,
    SetupCoupon,
    Typography,
    RewardCoin
  }
})
export default class SetupReferral extends Vue {
  @Prop(String) type?: TBusinessReferralType;
  @Prop(String) coins?: string;
  @Prop(String) percentage?: string;
  @Prop({ default: [] }) readonly errors?: string[];

  EBusinessReferralType = EBusinessReferralType;

  get tPrefix() {
    return 'referralProgram.creation.step-2';
  }

  get isReferring() {
    return (
      this.type === EBusinessReferralType.BOTH ||
      this.type === EBusinessReferralType.REFERRING
    );
  }

  get isReferred() {
    return (
      this.type === EBusinessReferralType.BOTH ||
      this.type === EBusinessReferralType.REFERRED
    );
  }

  get referredText() {
    if (this.type !== EBusinessReferralType.BOTH) return 'onlyReferred';
    return 'referred';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }
}
